import {writable} from 'svelte/store';

const opened = writable(true)
const overlay = writable(false)

export {
  opened, overlay
}
